import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {selectStore} from "../../../../../../store/selector";
import {Col, Input, Row, Skeleton, Typography, Select, Alert, Table} from "antd";
import {StyledButton} from "../../../../../../pages/Entrant/AdmissionWithoutRanking/index.styles";
import {ItemMarks} from "../../../EntrantApplication/ItemMarks";
import {
  educationDocumentRatingAction,
  fetchAddLessonProfileNewAction, fetchDeleteProfileNewLessonAction, fetchEditNewProfileLessonAction,
  fetchGetMarksAction
} from "../../../../../../store/pages/admission/actions";
import {IconError} from "../../../../../../assets";
import {decodeBase64} from "../../../../../../utils/decodeBase64";

const {Option} = Select

export const ExecutorStepTwo = ({
                                  setLocked,
                                  setCheckAuthorType,
                                  setCheckMarksValue,
                                  arr,
                                  setArr,
                                  currentCollege
                                }: any) => {
  const dispatch = useDispatch();
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps', 'common'])
  const [searchParams] = useSearchParams();

  const education_order_id = decodeBase64(searchParams.get("education_order_id"));

  const {admission:{getMarks, getInfo}} = useSelector(selectStore)

  const [checkVal, setCheckVal] = useState(true)

  const [visible, setVisible] = useState(null as any)

  useEffect(() => {
    if (getInfo.data) {
      setVisible(getInfo.data.educationOrder.base_education === "3" ? false
        : getInfo.data.educationOrder.base_education !== "3" && getInfo.data.educationOrder.declarant_status !== "1" ? false
          : getInfo.data.educationOrder.base_education === "3" && getInfo.data.educationOrder.declarant_status === "1" ? false
            : true)
    }
  }, [getInfo.data])

  //проверка до 30 предметов
  useEffect(() => {
    if (getMarks.data && getMarks.data.educationOrder.markList) {
      // setCheckVal(data.educationOrder.markList.commonWithRequired.length < 30)
    }
  }, [getMarks.data])


  useEffect(() => {
    // @ts-ignore
    dispatch(fetchGetMarksAction(education_order_id))
  }, [])

  // useEffect(() => {
  //   console.log("getMarks.data",getMarks.data)
  //
  //   if (getMarks.data && getMarks.data.educationOrder.markList.common && getMarks.data.educationOrder.markList.common[0].author_type === 4) {
  //     setLocked(false)
  //   }
  // }, [getMarks.data])

  useEffect(() => {
    if(getMarks.data && getMarks.data.educationOrder){
      let currentCollege = getMarks.data.educationOrder.current_college_id
      let priorityCollege = [] as any

      if(getMarks.data && Array.isArray(getMarks.data.educationOrder.selectedSpecialities)){
        priorityCollege = [...getMarks.data.educationOrder.selectedSpecialities]

        priorityCollege.sort((a:any, b:any) => a.priority > b.priority ? 1 : -1)[0].college_id
      }

      setLocked(currentCollege === priorityCollege)
    }
  }, [getMarks.data])

  useEffect(() => {
    if (getMarks.data && getMarks.data.educationOrder.markList.common) {
      setCheckAuthorType(getMarks.data.educationOrder.markList.common.some((item:any) => item.author_type === 4))
    }
  }, [getMarks.data])

  useEffect(() => {
    setArr([(prevState:any) => ([...prevState])])
  }, [getMarks.data])

  useEffect(() => {
    if (getMarks.data && getMarks.data.educationOrder.selectedSpecialities) {
      let newArr = getMarks.data.educationOrder.selectedSpecialities.map((item:any) => {
        return [...item.profileMarks]
      })
      setArr(getMarks.data.educationOrder.markList.common)
    }
  }, [getMarks.data])


  useEffect(() => {
    setCheckMarksValue(arr.every((item:any) => item.rating !== ""))
  }, [arr])

  const columns = [
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.specialty')}`,
      dataIndex: 'key',
      key: 'key',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.qualification')}`,
      dataIndex: 'qualification',
      key: 'qualification',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.college')}`,
      dataIndex: 'college',
      key: 'college',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.language')}`,
      dataIndex: 'language_of_education',
      key: 'language_of_education',
      width: "30%",
      render: (text:any) => {
        return(
          <div>
            {text}
          </div>
        )
      }
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.priority')}`,
      dataIndex: 'priority',
      key: 'priority',
      width: "10%",
      render: (text:any) => {
        return (
          <span className="admission__border-item">
            {text}
          </span>
        )
      }
    },
  ];

  const [dataState, setDataState] = useState({} as any)

  const addLessonItemButton = (data:any) => {

    setDataState({
      ...data,
      education_order_id: education_order_id,
      // rating_id: data.id,
      author_type: 3
    })
  }

  const addLessonMainHandler = () => {
    dispatch(fetchAddLessonProfileNewAction(dataState))

    addLessonItemButton({})
  }

  const handleItemRating = (value:any) => {
    setDataState((prev:any) => ({
      ...prev,
      rating: value
    }))
  }

  const handleItemSubjectName = (value:any) => {
    setDataState((prev:any) => ({
      ...prev,
      subject_name: value
    }))
  }

  const handleDeleteNewRating = (id:any) => {
    dispatch(fetchDeleteProfileNewLessonAction(id))
  }

  const handleEditNewRating = (value:any, id:any, selected_speciality_id:any, item:any) => {
    // @ts-ignore
    dispatch(fetchEditNewProfileLessonAction({
      selected_speciality_id,
      education_order_id,
      rating_id: id,
      rating: value,
    }))
  }



  const handleChangeDocumentRating = (count:any, rating:any) => {
    let body = {
      education_order_id: education_order_id,
      rating,
      count
    }

    // @ts-ignore
    dispatch(educationDocumentRatingAction(body))
  }

  const handleSortArr = () => {
    let sortedArr = [] as any

    if(getMarks.data && Array.isArray(getMarks.data.educationOrder.selectedSpecialities)) {
      sortedArr = [...getMarks.data.educationOrder.selectedSpecialities]

      sortedArr.sort((a: any, b: any) => a.priority > b.priority ? 1 : -1)
    }

    return sortedArr
  }

  return (
    <Skeleton loading={!getMarks.data}>
      <>

        <div className="admission__content-item">

          <Alert
            className="admission__error"
            message={(<Row><span>{t('admissionView:alert.stepTwo')} <span style={{color: "red"}}>{t('admissionView:alert.stepTwoWarn')}</span> {t('admissionView:alert.stepTwoLineTwo')}</span></Row>)}

            type="warning"
            showIcon
            icon={<IconError />}
          />

        </div>

        {/*<div className="admission__content-item">*/}
        {/*  <h3 className="admission__subtitle">{t('admissionView:stepsTitle.stepTwo.title.confirmation')}</h3>*/}
        {/*  {locked && checkVal && currentCollege.status === '32' &&*/}
        {/*    <AddLesson*/}
        {/*      title={t('admissionView:stepsTitle.stepTwo.caption.addSimpleLesson')}*/}
        {/*      handleLessonRating={handleLessonRating}*/}
        {/*      handleLessonSubjectName={handleLessonSubjectName}*/}
        {/*      addLessonHandler={addLessonHandler}*/}
        {/*      addLessonItem={addLessonItem}*/}
        {/*    />*/}
        {/*  }*/}

        {/*</div>*/}

        <div className="admission__content-item">
          {
            [5, 4, 3, 2].map((item, index) => (
              <Row className="marks__item" style={{marginBottom: 16}} key={item}>
                <Col flex="46px">
                  <Input disabled={!(getMarks?.data?.educationOrder?.current_college_id === currentCollege.college_id && (currentCollege.status === "32" || currentCollege.status === "29"))} className='marks__input' onBlur={(e) => handleChangeDocumentRating(e.target.value, item)} maxLength={2} onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }} defaultValue={getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.educationDocument.ratings[index].count}/>
                </Col>
                <Col style={{marginLeft: 16}}>
                  <Typography.Text style={{marginLeft: 0}}>{t('admissionView:countInEducationDocument', {item: item})}</Typography.Text>
                </Col>
              </Row>
            ))
          }


          <Row gutter={16}>
            <Col>
              <Alert
                message={<span>{t('admissionView:totalAvgSubject')} <strong style={{marginLeft: 16}}>{getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.educationDocument.count}</strong></span>}
                type="success"
              />
            </Col>

            <Col>
              <Alert
                message={<span>{t('admissionView:totalAvgRating')} <strong style={{marginLeft: 16}}>{getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.educationDocument.avg_rating}</strong></span>}
                type="warning"
              />
            </Col>
          </Row>
        </div>

        <div className="admission__content-item">

          <div className="admission__content-item">

            <Row>
              {handleSortArr().map((item:any) => {
                const dataSource = [
                  {
                    key: item.speciality.code + ' - ' + item.speciality.caption,
                    qualification: item.qualification.code + ' - ' + item.qualification.caption,
                    college: item.college.name,
                    priority: item.priority,
                    language_of_education: item.language_of_education == 1 ? t("common:kz") : item.language_of_education == 2 ? t("common:ru") : item.language_of_education == 3 ? "Английский" : "Неверный язык заявления",
                    specialityId: item.speciality_id,
                  }
                ]

                let checkCollege = item.college_id === getMarks.data.educationOrder.current_college_id
                return (
                  <Col span={24} style={{marginBottom: 16}} key={item.id}>
                    <div className="result">
                      <Table
                        dataSource={dataSource}
                        columns={columns}
                        className={"admission__table admission__table--" + item.statusValidate}
                        bordered={true}
                        pagination={false}
                      />

                      <Row gutter={12} style={{padding: 24}}>
                        <Col span={12}>
                          <ItemMarks
                            headerTitle={t("admissionView:stepsTitle.stepTwo.title.required")}
                            headerColor={item.statusValidate}
                            selectedSpecialityId={item.id}
                            // footerVisible={checkCollege && (item.status === '32')}
                            footerVisible={false}
                            data={item.requiredMarksByLang}
                            disabledInput={!checkCollege || (currentCollege.status != '32' && currentCollege.status != '29')}
                            span={24}
                            addLessonFooterVisibleHandler={addLessonItemButton}
                            item={item}
                            type='required'

                            canDelete={checkCollege}

                            handleEditRating={handleEditNewRating}
                            handleDeleteRating={handleDeleteNewRating}
                          />
                        </Col>

                        <Col span={12}>
                          <ItemMarks
                            headerTitle={t("admissionView:stepsTitle.stepTwo.title.profile")}
                            headerColor={item.statusValidate}
                            selectedSpecialityId={item.id}
                            // footerVisible={checkCollege && (item.status === '32')}
                            footerVisible={false}
                            data={item.profileMarks}
                            disabledInput={!checkCollege || (currentCollege.status != '32' && currentCollege.status != '29')}
                            span={24}
                            addLessonFooterVisibleHandler={addLessonItemButton}
                            item={item}
                            type='profile'

                            canDelete={checkCollege}

                            handleEditRating={handleEditNewRating}
                            handleDeleteRating={handleDeleteNewRating}
                          />
                        </Col>
                      </Row>

                      {
                        item.id === dataState.id &&
                          <div className="admission__content-item" style={{padding: 24}}>
                              <Typography.Text style={{
                                marginBottom: "12px",
                                display: "block"
                              }}>Добавить <strong>{dataState.type === 'required' ? t("admissionView:stepsTitle.stepTwo.title.required") : t("admissionView:stepsTitle.stepTwo.title.profile")}</strong></Typography.Text>

                              <Row gutter={[16, 16]}>

                                  <Col flex="58px">

                                      <Select
                                          suffixIcon={null}
                                          className="marks__input"
                                          onChange={(value:any) => handleItemRating(value)}
                                          defaultValue={dataState.rating && dataState.rating}
                                          value={dataState.rating && dataState.rating}
                                      >
                                          <Select.Option value="2">2</Select.Option>
                                          <Select.Option value="3">3</Select.Option>
                                          <Select.Option value="4">4</Select.Option>
                                          <Select.Option value="5">5</Select.Option>
                                      </Select>

                                  </Col>

                                  <Col span={18}>
                                      <Input
                                          onChange={(e:any) => handleItemSubjectName(e.target.value)}
                                          style={{borderRadius: '8px'}}
                                          placeholder={t('admissionView:stepsCaptions.lessonTitle')}
                                          defaultValue={dataState.subject_name && dataState.subject_name}
                                          value={dataState.subject_name && dataState.subject_name}
                                      />
                                  </Col>

                                  <Col>
                                      <StyledButton
                                          className="admission__button col-green br-green"
                                          onClick={() => addLessonMainHandler()}
                                          disabled={!(dataState.rating && dataState.subject_name)}
                                      >
                                        {t('admissionView:stepsButton.addLesson')}
                                      </StyledButton>
                                  </Col>
                              </Row>
                          </div>
                      }

                    </div>
                  </Col>
                )
              })}
            </Row>
          </div>


        </div>
      </>
    </Skeleton>
  )
}